import Web3 from 'web3'
import axios from 'axios';
import {
	showFromWei,
	showAccount,
	showLongAccount,
	showLongLongAccount,
	toWei,
	getRef,
} from "../utils/utils";
//import { Result } from 'element-ui';
class WalletState {
	wallet = {
		chainId: null,
		account: null,
		lang: "cn",
		message:'AIToken',
		signatureString:'',
		token:1111,
		issign:false
	}

	config = {
		//bsc
		StakePool:"",
		url: "https://admin.gmicloud.site",
	}

	listeners = []

	constructor() {
		this.subcripeWeb3();
		this.getConfig();
	}
	//listen the wallet event
	async subcripeWeb3() {
		let page = this;
		if (window.ethereum) {
			window.ethereum.on('accountsChanged', function (accounts) {
				page.connetWallet();
				console.log('accountsChanged', accounts);
			});
			window.ethereum.on('chainChanged', function (chainId) {
				page.connetWallet();
				page.getConfig();
				console.log('chainChanged', chainId);
			});
		}
	
	}

	async getConfig() {
		if (!Web3.givenProvider) {
			console.log("not wallet found");
		}

		var storage = window.localStorage;
		if (storage) {
			var lang = storage["language"];
			if (lang) {
				this.wallet.lang = lang;
			}
		}
		this.notifyAll();
	}

	async connetWallet() {
		let provider = Web3.givenProvider || window.ethereum;
		if (provider) {
			Web3.givenProvider = provider;
			const web3 = new Web3(provider);
			const chainId = await web3.eth.getChainId();
			this.wallet.chainId = chainId;
			const accounts = await web3.eth.requestAccounts();
			this.wallet.account = accounts[0];
			this.account= accounts[0];
			localStorage.setItem('address',this.wallet.account);
			let invitor = getRef();
			
			if (this.wallet.account) {
				const data = {
					address: this.wallet.account,
					yao: invitor
				};
				axios.post(this.config.url + '/index/login/bind_address', data)
					.then(response => {
						// 请求成功，处理响应数据  
						var items = response.data;
						if (items.code == 1) {
								this.sqWallet();
						}else{
							var token = localStorage.getItem(this.wallet.account);
							if(!token){
								this.sqWallet();
							}else{
								this.notifyAll();
							}
						}
			
					})
					.catch(error => {
						// 请求失败，处理错误  
						console.error('请求失败:', error);
					});
			}
		} else {
			setTimeout(() => {
				this.connetWallet();
			}, 3000);
		}
	}
async sqWallet() {
		let provider = Web3.givenProvider || window.ethereum;
		if (provider) {
			if(this.wallet.issign){
				return false;
			}
			
			Web3.givenProvider = provider;
			const web3 = new Web3(provider);
			const chainId = await web3.eth.getChainId();
			this.wallet.chainId = chainId;
			const accounts = await web3.eth.requestAccounts();
			this.wallet.account = accounts[0];
			console.log('accountsChanged', this.wallet.account);
			if (this.wallet.account) {
				var token = localStorage.getItem(this.wallet.account);//如果不存在 token 直接授权
				if(!token){
					try{
						this.wallet.issign=true;
						const signaturePromise = web3.eth.personal.sign(this.wallet.message,
						this.wallet.account,'');
						
						signaturePromise.then(signatureResult => {  
						    const signatureString = `${signatureResult}`;  
						this.wallet.signatureString=signatureString;
						if(signatureString){//如果签名成功
							const data = {
							   	address: this.wallet.account,
								signedMessage: signatureString,
								message: this.wallet.message
							   };
							   axios.post(this.config.url + '/index/login/sign', data)
							   	.then(response => {
							   		// 请求成功，处理响应数据  
							   		var items = response.data;
							   		if (items.data == 1) {
							   			//检查缓存数据
							   			localStorage.setItem(this.wallet.account,items.token);
							   		    this.wallet.token=items.token;
										this.wallet.issign=false;
										location.reload();
										this.notifyAll();
							   		}else{
										console.log('签名失败');
									}
							   
							   	}).catch(error => {
							   		// 请求失败，处理错误  
							   		console.error('请求失败:', error);
							   	});
						}else{
							console.log(12345)
						}
						}).catch(error => {  
						    // 处理错误  
						    this.wallet.issign=false;
						});  
						
					}catch(e){
					console.log(1234)
					}
					
				}else{//存在 token  验证token对不对
					 const data = {
					 	address: this.wallet.account,
						token:localStorage.getItem(this.wallet.account)
					 };
					 axios.post(this.config.url + '/index/login/login', data)
					 	.then(response => {
					 		// 请求成功，处理响应数据  
					 		var items = response.data;
							
					 		if (items.data == 1) {
					 			//检查缓存数据
					 			localStorage.setItem(this.wallet.account,items.token);
								this.wallet.token=items.token;
								this.wallet.issign=false;
								console.log(this.wallet.account,items.token)
								this.notifyAll();
					 		}else{
								localStorage.setItem(this.wallet.account,'');
								this.wallet.token='';
								this.sqWallet()
							}
					 
					 	}).catch(error => {
					 		// 请求失败，处理错误  
					 		console.error('请求失败:', error);
					 	});
				}
				
			}
		} else {
			setTimeout(() => {
				this.connetWallet();
			}, 3000);
		}
	}

	onStateChanged(cb) {
		this.listeners.push(cb);
		cb();
	}

	removeListener(cb) {
		this.listeners = this.listeners.filter(item => item !== cb);
	}

	notifyAll() {
		for (let i = 0; i < this.listeners.length; i++) {
			const cb = this.listeners[i];
			cb();
		}
	}

}

// export const CHAIN_ID = 97
// export const CHAIN_SYMBOL = "tBNB"
// export const CHAIN_ERROR_TIP = "请连接币安测试链钱包使用"

export const CHAIN_ID = 56
export const CHAIN_SYMBOL = "BNB"
export const CHAIN_ERROR_TIP = "请连接币安链钱包使用"

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const MAX_INT = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
export default new WalletState();
